<template>
  <div class="table-content">
    <div class="fun">
      <div class="funLeft">
        <!-- <div class="input one">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="customerName" placeholder="请输入姓名">
        </div>
        <div class="input ">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="mobile" placeholder="请输入手机号">
        </div>
        <div class="input ">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="certNo" placeholder="请输入身份证号">
        </div> -->
      </div>
    </div>
    <div class="btn">
        <el-row>
          <!-- <el-button class="search" size="mini" @click="search()">搜索</el-button>
          <el-button class="deltale" size="mini" @click="deltale()">清除</el-button> -->
          <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
        </el-row>
      </div>
    <el-table class="loadingPrivate" max-height="500" :data="tableData" style="width: 100%,font-size:0.5rem,margin-bottom:1rem,margin-top: 0.5rem,">
      <el-table-column prop="realname" label="客户类别" width="100"></el-table-column>
      <el-table-column prop="realname" label="是否在职" width="100"></el-table-column>
      <el-table-column prop="realname" label="公司" width="180"></el-table-column>
      <el-table-column prop="realname" label="中支" width="180"></el-table-column>
      <el-table-column prop="realname" label="营服" width="180"></el-table-column>
      <el-table-column prop="realname" label="姓名" width="100"></el-table-column>
      <el-table-column prop="idCard" label="身份证号" width="150"></el-table-column>
      <!-- <el-table-column prop="phone" label="手机号" width="125"></el-table-column> -->
      <el-table-column prop="contractNo" label="合同号" width="150"></el-table-column>
      <el-table-column prop="loanNo" label="借据号" width="150"></el-table-column>
      <el-table-column prop="loanTerm" label="期数" width="100"></el-table-column>
      <el-table-column prop="repaymentAmount" label="逾期总额(元)" width="120"></el-table-column>
      <el-table-column prop="principal" label="本金(元)" width="120"></el-table-column>
      <el-table-column prop="interest" label="利息(元)" width="120"></el-table-column>
      <el-table-column prop="overdueAdd" label="罚息(元)" width="120"></el-table-column>
      <el-table-column prop="dateFormat" label="逾期时间(开始)" width="150"></el-table-column>
      <el-table-column prop="overdueDate" label="当前逾期天数(截止)" width="150"></el-table-column>
      <el-table-column prop="overdueDate" label="当前是否逾期" width="150"></el-table-column>
      <el-table-column prop="overdueDate" label="还款日期" width="150"></el-table-column>
      <el-table-column prop="identityType" label="贷款类型" width="100"></el-table-column>
    </el-table>
    <!-- <div class="summation">
        <p>合计</p>
        <p>逾期人数：{{overduePeopleNumber}} 人</p>
        <p>逾期笔数：{{overdueListNumber}} 笔</p>
        <p>逾期金额：{{overdueMoneyNumber}} 元</p>
    </div> -->
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "loans3", //历史逾期数据表
    data() {
      return {
        tableData: [],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 20, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        isPage: true,
        certNo: '', //被推荐人身份证号
        customerName: '', //被推荐人姓名
        mobile: '', //被推荐人手机号
        totalCount: '', //总条数
        pagNum: '', //总页数
        token: "",
        pageNumber: 1,
        pageSize: 15,
        startTime: "", //开始时间
        endTime: "", //结束时间
        selectData: [], //导出excel文件
        excelData: [],
        //请求参数
        req: {
          toRecommendIdcard1: '', //被推荐人身份证号
          toRecommendName1: '', //被推荐人姓名
          toRecommendMobile1: '', //被推荐人手机号
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        },
        //合计
        overduePeopleNumber:"",//逾期人数
        overdueListNumber:"",//逾期笔数
        overdueMoneyNumber:"",//逾期金额
      }
    },
    props: {
      pageTotal: Number
    },
    created() {
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.firstSearch()
    //   this.pagNumS()
    },
    mounted() {

    },
    methods: {
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
        //   toRecommendIdcard: this.req.toRecommendIdcard1, //被推荐人身份证号
        //   toRecommendName: this.req.toRecommendName1, //被推荐人姓名
        //   toRecommendMobile: this.req.toRecommendMobile1, //被推荐人手机号
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize
        };
        console.log('66666666666', params)
        let _this = this;
        let url =  '/ft-oms/overdueController/overdueNowList.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {
        this.$emit('handleSizeChange', page_size);
        console.log('t5555', this.$emit)
      },
      //获取开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var youWant = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
        console.log("33333333", youWant)
        if (youWant == "1970/1/1") {
          youWant = ""
        }
        this.startTime = youWant
        // this.endTime = youWant2
      },
      //获取结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate();
        console.log(youWant2)
        if (youWant2 == "1970/1/1") {
          youWant2 = ""
        }
        // this.startTime = youWant
        this.endTime = youWant2
      },
      //首次进入加载数据
      firstSearch() {
        let params = {
        //   toRecommendIdcard: '', //被推荐人身份证号
        //   toRecommendName: '', //被推荐人姓名
        //   toRecommendMobile: '', //被推荐人手机号
          token: this.token,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        };
        let _this = this;
        let url = '/ft-oms/overdueController/overdueNowList.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount) //向上取整 parseInt(Math.ceil(res.data.data.totalCount/15))
            this.overduePeopleNumber = res.data.data.overdueNumber
            this.overdueListNumber = res.data.data.overdueTimes
            this.overdueMoneyNumber = res.data.data.overdueAmount
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //得到数据
      getData() {
        let params = {
        //   toRecommendIdcard: this.certNo, //被推荐人身份证号
        //   toRecommendName: this.customerName, //被推荐人姓名
        //   toRecommendMobile: this.mobile, //被推荐人手机号
          token: this.token,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        };

        this.req.toRecommendIdcard1 = params.toRecommendIdcard
        this.req.toRecommendName1 = params.toRecommendName
        this.req.toRecommendMobile1 = params.toRecommendMobile
        let _this = this;
        let url =  '/ft-oms/overdueController/overdueNowList.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.overduePeopleNumber = res.data.data.overdueNumber
            this.overdueListNumber = res.data.data.overdueTimes
            this.overdueMoneyNumber = res.data.data.overdueAmount
            this.currentPage1 = 1
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = []
            this.isPage = false
          }
        }, );
      },
      //搜索开户明细
      search() {
        if((this.startTime!=''&&this.endTime!='')||(this.startTime==''&&this.endTime=='')){
        this.getData()
        }else{
          this.$alert('请选择开始日期或结束日期', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
                // this.$message({
                // type: 'info',
                // message: `action: ${ action }`
                // });
            }
          });
        }
      },
      //清除数据
      deltale() {
        this.certNo = "";
        this.customerName = ""
        this.mobile = ""
      },
      //导出
      doexcel() {
        let params = {
        //   toRecommendIdcard: this.req.toRecommendIdcard1, //被推荐人身份证号
        //   toRecommendName: this.req.toRecommendName1, //被推荐人姓名
        //   toRecommendMobile: this.req.toRecommendMobile1, //被推荐人手机号
          token: this.token,
        };
        let _this = this;
        let url =  '/ft-oms/overdueController/overdueNowListExl.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          } else{
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
        }, );
      },
    }
  }

</script>

<style scoped>
  .pagination {
    /* margin-bottom: 1.2rem; */
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;

  }

  .header {
    height: 3rem;
    display: flex;
  }

  .filiale,
  .input {
    margin-right: 1rem;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 12rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input1 {
    margin-left: 0.5rem
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 6rem;
    outline: none;
  }
  .input input:focus{
    border-color: #FF9D47;
  }
  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }

  .fun {
    display: flex;
    margin-bottom: 1rem;
    /* justify-content: space-between;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eeeeee; */
  }
  .funLeft{
    display: flex;
  }
  .funRight{
    display: flex;
  }
  .btn{
      display: flex;
      float: right;
  }
  .one{
      width:10rem;
  }
  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.8rem;
    line-height: 1.8rem;
    width: 2.4rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
    /* margin-right: 0.6rem; */
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    /* height: 1.8rem;
    line-height: 1.8rem;
    width: 2.4rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
    /* margin-right: 0.6rem; */
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.8rem;
    line-height: 1.8rem;
    width: 2.4rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxImg {
    width: 4.8rem;
    height: 1.2rem;
    border: 1px solid #999999;
    background: url("../../../static/img/sousuo-2.png") no-repeat center right;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }

  /* .determineCls {
    width: 76px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #999999;
    font-size: 12px;
    margin: 3px auto;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
  } */

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: '';
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background: #FF9D47;
    border-color: #FF9D47;
    color: #FF9D47;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check:after {
    transform: rotate(45deg) scaleY(1);
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: '';
    border: 0.01rem solid #fff;
    border-left: 0;
    border-top: 0;
    height: 0.5rem;
    left: 0.1rem;
    position: absolute;
    top: 0.01rem;
    transform: rotate(45deg) scaleY(0);
    width: 0.4rem;
    transition: transform 0.05s ease-in 0.05s;
    transform-origin: center;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 0.02rem;
    border: 0.01rem solid #D9EBFE;
    border-radius: 0.02rem;
    box-sizing: border-box;
    width: 0.8rem;
    height: 0.8rem;
    border-color: #D9EBFE;
    z-index: 1;
    transition: border-color 0.05s cubic-bezier(.71, -.49, .26, 1.46), background-color 0.05s cubic-bezier(.71, -.49, .26, 1.46);
  }

  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }

  .el-table__header-wrapper {
    background: #fff;
  }

  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #bfcbd9;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }

  .startDate,
  .endDate {
    margin-right: 1rem;
  }

  .startDate>>>.el-date-editor {
    width: 8rem;
  }

  .endDate>>>.el-date-editor {
    width: 8rem;
  }

  .filiale>>>.el-input__inner {
    width: 8rem;
  }

  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }
  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }
  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 8rem;
  }

  .startDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  .endDate>>>.el-date-editor {
    width: 8rem;
  }
  .endDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  
  /*修改下拉框样式*/
  .filiale>>>.el-input__inner{
    width: 8rem;
  }
  /* .el-select-dropdown__wrap {
    background: #b5879a !important;
  } */
  .filiale>>>.el-select .el-input.is-focus .el-input__inner{
    border-color: #FF9D47;
  }
  .filiale>>>.el-select .el-input__inner:focus{
    border-color: #FF9D47;

  }
  .el-select-dropdown__item.selected{
    color: #FF9D47;
  }
  .filiale>>>.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #FAF0E7;
    color: #FF9D47;
  }
  
  /*修改分页样式*/
  .pagination>>>.el-pager li.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pager li:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-next:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-prev:hover{
    color: #FF9D47;
  }
  /*按钮样式*/
  .doexcel>>> .el-button--default .el-button--mini:hover{
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }
  .search>>>.el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }
  .deltale>>> .el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }
  .filiale >>>.el-select-dropdown__wrap{
    max-height: 295px;
  }
  .summation{
      margin: 1rem ;
      width: 60%;
      display: flex;
      justify-content: space-between;
      font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// loans3.vue?722e749c